import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { MARK_ALL_NOTIFICATIONS_AS_READ } from '../../graphQLDefs/Notifications/mutations';

interface UseMarkAllNotificationsAsReadOptions {
  onSuccess?: () => void | Promise<void>;
  onError?: (error: Error) => void;
}

export const useMarkAllNotificationsAsRead = (
  options: UseMarkAllNotificationsAsReadOptions = {}
) => {
  const { onSuccess, onError } = options;

  const [markAllNotificationsAsReadMutation, { loading, error }] = useMutation(
    MARK_ALL_NOTIFICATIONS_AS_READ,
    {
      onError: error => {
        console.error('Mark all notifications as read error:', error);
        onError?.(error);
      },
    }
  );

  const markAllAsRead = useCallback(async () => {
    try {
      const result = await markAllNotificationsAsReadMutation({
        variables: { data: {} },
      });
      if (result.data?.markAllNotificationsAsRead.__typename === 'MarkAllAsRead') {
        await onSuccess?.();
      } else if (result.data?.markAllNotificationsAsRead.__typename === 'Error') {
        throw new Error(result.data.markAllNotificationsAsRead.message);
      }
      return result;
    } catch (error) {
      console.error('Failed to mark all notifications as read:', error);
      throw error;
    }
  }, [markAllNotificationsAsReadMutation, onSuccess]);

  return {
    markAllAsRead,
    loading,
    error,
  };
};
